import { render } from "./BaseTemplate.vue?vue&type=template&id=d2132462&ts=true"
import script from "./BaseTemplate.vue?vue&type=script&lang=ts"
export * from "./BaseTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__